import React from "react";
import { Modal } from "react-bootstrap";
import { ButtonComponent } from "../../components/buttonComponent";

const ServerLogViewPopup = ({ hideSerilogPopup, log }) => {
  return (
    <Modal
      show={true}
      onHide={hideSerilogPopup}
      centered
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="example-modal-sizes-title-lg"
          className="cm-modal-header-title"
        >
          Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          <div className="form-group">
            <div className="row">
              <div className=" col-md-2">
                <label className="font-weight-bold">Level</label>
              </div>
              <div className="col-md-10">
                <span>{log.level}</span>
              </div>
            </div>
            <div className="row">
              <div className="col-md-2">
                <label className="font-weight-bold">Date</label>
              </div>
              <div className="col-md-10">
                <span>{log.utcDateTimeStamp}</span>
              </div>
            </div>
            <div className="row">
              <div className="col-md-2">
                <label className="font-weight-bold">Message</label>
              </div>
              <div className="col-md-10">
                <span>{log.renderedMessage}</span>
              </div>
            </div>
            {log.exceptionMessage && (
              <div className="row">
                <div className="col-md-2">
                  <label className="font-weight-bold">Exception Message</label>
                </div>
                <div className="col-md-10">
                  <label>{log.exceptionMessage}</label>
                </div>
              </div>
            )}

            {log.exceptionStackTrace && (
              <div className="row">
                <div className=" col-md-2">
                  <label className="font-weight-bold">
                    Exception StackTrace
                  </label>
                </div>
                <div className="col-md-10">
                  <span style={{ overflowWrap: "break-word" }}>
                    {log.exceptionStackTrace}
                  </span>
                </div>
              </div>
            )}
          </div>
        </>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-md-12 col-xs-12 text-right">
          <ButtonComponent
            type="button"
            labelId="button.cancel"
            className="btn-sm btn-light mr-2 ml-1"
            onClick={hideSerilogPopup}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ServerLogViewPopup;
